import { notifyError } from "../components/Toast";
import { fetchWithAuth } from '../auth/fetchWithAuth';
const API_URL = process.env.REACT_APP_API_BASE_URL;


export const fetchGeneralEvaluation = (process, codUnit, codSede, user) => {
  return async (dispatch) => {
    dispatch({ type: "FETCH_GENERAL_EVALUATION_REQUEST" });

    try {
      const params = new URLSearchParams({
        proceso: process,
        codUnidad: codUnit ?? '',
        codSede: codSede ?? '',
      }).toString();

      const response = await fetchWithAuth(`${API_URL}reportes/evaluaciones-generales?${params}`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + user.token
        },
      });

      if (response.ok) {
        const data = await response.json();
        const evaluation = data[0] ?? {};
        
        dispatch({ type: "FETCH_GENERAL_EVALUATION_SUCCESS", payload: evaluation });
        return data;

      } else {
        const errorData = await response.json();
        notifyError(errorData.message || "Error al guardar la evaluación");
        dispatch({ type: "FETCH_GENERAL_EVALUATION_FAIL", payload: errorData.message });
      }

    } catch (error) {
      notifyError("Error de conexión");
      dispatch({ type: "FETCH_GENERAL_EVALUATION_FAIL", payload: error.message });
      throw error;
    }
  };
};

export const UpdateGeneralEvaluationObservation = (evaluation, observation, user) => {
  return async (dispatch) => {
    dispatch({ type: "SAVE_GENERAL_EVALUATION_REQUEST" });
    
    try {

      const response = await fetchWithAuth(`${API_URL}reportes/evaluaciones-generales/${evaluation}/observacion`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + user.token
        },
        body: JSON.stringify(observation),
      });

      if (response.ok) {
        dispatch({ type: "SAVE_GENERAL_EVALUATION_SUCCESS", payload: evaluation });
      } else {
        const errorData = await response.json();
        notifyError(errorData.message || "Error al guardar la evaluación");
        dispatch({ type: "SAVE_GENERAL_EVALUATION_FAIL", payload: errorData.message });
      }

    } catch (error) {
      notifyError("Ha ocurrido un error: " + error.message);
      dispatch({ type: "FETCH_GENERAL_EVALUATION_FAIL", payload: error.message });
    }
  };
};

export const getEvaluation = (evaluationId, user) => {
  return async (dispatch) => {
    dispatch({ type: "GET_EVALUATION_REQUEST" });

    try {
      const params = new URLSearchParams({
        evaluacion: evaluationId,
        criterio: '',
        codUnidad: '',
        codSede: '',
        evaluacionGeneral: '',
      }).toString();

      const response = await fetch(`${API_URL}reportes/evaluaciones?${params}`, {
        method: "GET",
        headers: { 
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + user.token
        },
      });

      if (response.ok) {
        const data = await response.json();
        const evaluation = data[0] ?? {};

        dispatch({ type: "GET_EVALUATION_SUCCESS", payload: evaluation });
        return data;

      } else {
        const errorData = await response.json();
        notifyError(errorData.message || "Error al guardar la evaluación");
        dispatch({ type: "GET_EVALUATION_FAIL", payload: errorData.message });
      }
    } catch (error) {
      notifyError("Error de conexión");
      dispatch({ type: "GET_EVALUATION_FAIL", payload: error.message });
      throw error;
    }
  };
};

export const saveAssessment = (evaluationId, assessment, user) => {
  return async (dispatch) => {
    dispatch({ type: "SAVE_VALORACION_REQUEST" });
    
    try {
      const response = await fetch(`${API_URL}reportes/evaluacion/${evaluationId}/valoracion`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + user.token
        },
        body: JSON.stringify(assessment),
      });

      if (response.ok) {
        
        dispatch({ type: "SAVE_VALORACION_SUCCESS" });
        dispatch(getEvaluation(evaluationId, user));

      } else {
        const errorData = await response.json();
        notifyError(errorData.message || "Error al guardar la valoración");
        dispatch({ type: "SAVE_VALORACION_FAIL", payload: errorData.message });
      }
    } catch (error) {
      notifyError(error);
      dispatch({ type: "SAVE_VALORACION_FAIL", payload: error.message });
    }
  };
};

export const deleteAssessment = (evaluationId, assessmentId, user) => {
  return async (dispatch) => {
    dispatch({ type: "DELETE_VALORACION_REQUEST" });
    
    try {
      const response = await fetch(`${API_URL}reportes/evaluacion/valoracion/${assessmentId}`, {
        method: "DELETE",
        headers: { 
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + user.token
        },
      });

      if (response.ok) {
        
        dispatch({ type: "DELETE_VALORACION_SUCCESS" });
        dispatch(getEvaluation(evaluationId, user));

      } else {
        const errorData = await response.json();
        notifyError(errorData.message || "Error al eliminar la valoración");
        dispatch({ type: "DELETE_VALORACION_FAIL", payload: errorData.message });
      }
    } catch (error) {
      notifyError(error);
      dispatch({ type: "DELETE_VALORACION_FAIL", payload: error.message });
    }
  };
};

export const saveAttribute = (evaluationId,attribute,user) => {
  return async (dispatch) => {
    dispatch({ type: "SAVE_CUALIDAD_REQUEST" });
    
    try {
      const response = await fetch(`${API_URL}reportes/evaluacion/${evaluationId}/cualidad`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + user.token 
        },
        body: JSON.stringify(attribute),
      });

      if (response.ok) {

        dispatch({ type: "SAVE_CUALIDAD_SUCCESS" });
        dispatch(getEvaluation(evaluationId,user));

      } else {
        const errorData = await response.json();
        notifyError(errorData.message || "Error al guardar la cualidad");
        dispatch({ type: "SAVE_CUALIDAD_FAIL", payload: errorData.message });
      }
    } catch (error) {
      notifyError("Error de conexión");
      dispatch({ type: "SAVE_CUALIDAD_FAIL", payload: error.message });
    }
  };
};

export const deleteAttribute = (attributeId,evaluationId,user) => {
  return async (dispatch) => {
    dispatch({ type: "DELETE_CUALIDAD_REQUEST" });
    
    try {
      const response = await fetch(`${API_URL}reportes/evaluaciones/cualidad/${attributeId}`, {
        method: "DELETE",
        headers: { 
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + user.token 
        },
      });

      if (response.ok) {
        dispatch({ type: "DELETE_CUALIDAD_SUCCESS", payload:attributeId });
        dispatch(getEvaluation(evaluationId,user));

      } else {
        const errorData = await response.json();
        notifyError(errorData.message || "Error al eliminar la cualidad");
        dispatch({ type: "DELETE_CUALIDAD_FAIL", payload: errorData.message });
      }
    } catch (error) {
      notifyError("Error de conexión");
      dispatch({ type: "DELETE_CUALIDAD_FAIL", payload: error.message });
    }
  };
};

export const SaveEvaluationReview = (evaluationId, review, user) => {
  return async (dispatch) => {
    dispatch({ type: "SAVE_REVISION_REQUEST" });
    
    try {
      const response = await fetch(`${API_URL}reportes/evaluaciones/${evaluationId}/revisiones`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + user.token
        },
        body: JSON.stringify(review),
      });

      if (response.ok) {
        dispatch({ type: "SAVE_REVISION_SUCCESS" });
      } else {
        const errorData = await response.json();
        notifyError(errorData.message || "Hubo un error al guardar la valoracion");
        dispatch({ type: "SAVE_REVISION_FAIL", payload: errorData.message });
      }
    } catch (error) {
      notifyError(error);
      dispatch({ type: "SAVE_REVISION_FAIL", payload: error.message });
    }
  };
};

export const DeleteEvaluationReview = (reviewId, user) => {
  return async (dispatch) => {
    dispatch({ type: "DELETE_REVISION_REQUEST" });
    
    try {
      const response = await fetch(`${API_URL}reportes/evaluaciones/revisiones/${reviewId}`, {
        method: "DELETE",
        headers: { 
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + user.token
        },
      });

      if (response.ok) {
        dispatch({ type: "DELETE_REVISION_SUCCESS" });

      } else {
        const errorData = await response.json();
        notifyError(errorData.message || "Error al eliminar la valoración");
        dispatch({ type: "DELETE_REVISION_FAIL", payload: errorData.message });
      }
    } catch (error) {
      notifyError(error);
      dispatch({ type: "DELETE_REVISION_FAIL", payload: error.message });
    }
  };
};

